<template>
  <div class="create_wrapper fadeIn">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between">
            <upload-image-direct
              @loading="btnIsLoading = $event"
              @inputChanged="uplodeImg_1"
              title="صورة الطرد"
              model="package_categories"
            ></upload-image-direct>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  @keypress="isArabic"
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.ar.name"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.name_ar") }}
                </label>
              </div>
            </div>

            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  @keypress="isEnglish"
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.en.name"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.name_en") }}
                </label>
              </div>
            </div>

            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label"> النوع </label>
                <multiselect
                  v-model="data.type"
                  :options="types"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                ></multiselect>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model="data.price_km"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.price_km") }}
                </label>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model="data.base_fire_price"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.base_fire_price") }}
                </label>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model="data.base_fire_km"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.base_fire_km") }}
                </label>
              </div>
            </div>
            <div class="col-12 py-0">
              <v-checkbox
                :label="$t('forms.labels.is_active')"
                v-model="data.is_active"
                color="success"
              ></v-checkbox>
            </div>

            <!-- <div class="col-12 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.priority") }}
                </label>
                <input
                  type="number"
                  class="form-control"
                  rows="5"
                  v-model="data.priority"
                />
              </div>
            </div> -->
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="button_style_1" :disabled="btnIsLoading">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",

  data() {
    return {
      loading: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.categories.title"),
          disabled: false,
          href: "/packages/show-all",
        },
        {
          text: this.$t("breadcrumb.categories.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== create_data
      data: {
        image: null,
        ar: {
          name: null,
        },
        en: {
          name: null,
        },
        type: null,
        price_km: null,
        base_fire_price: null,
        base_fire_km: null,
        is_active: false,
      },

      // Fixed Data
      types: [
        {
          id: "gas_connection",
          name: "الاتصال بالغاز",
        },
        {
          id: "large_shipment",
          name: "الشحن الكبير",
        },
        {
          id: "special_purpose",
          name: "الغرض الخاص",
        },
        {
          id: "furniture_moving",
          name: "نقل الأثاث",
        },
      ],
    };
  },

  methods: {
    getCategories() {
      this.$axios.get("store_category_not_paginated").then((res) => {
        // console.log(res.data)
        this.categories = res.data.data.map((el) => {
          return { id: el.id, name: `${el.name}` };
        });
      });
    },
    uplodeImg_1(obj) {
      console.log(obj);
      this.data.image = obj;
    },
    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;

      if (!this.data.image) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.image"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.ar.name) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.name_ar"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.en.name) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.name_en"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.type) {
        this.$iziToast.error({
          timeout: 2000,
          message: "يرجي اختيار نوع الطرد",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.price_km) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.price_km"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.base_fire_price) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.base_fire_price"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.base_fire_km) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.base_fire_km"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      this.btnIsLoading = true;

      const submit_data = new FormData();

      submit_data.append("image", this.data.image);
      submit_data.append("ar[name]", this.data.ar.name);
      submit_data.append("en[name]", this.data.en.name);
      submit_data.append("type", this.data.type.id);
      submit_data.append("price_km", this.data.price_km);
      submit_data.append("base_fire_price", this.data.base_fire_price);
      submit_data.append("base_fire_km", this.data.base_fire_km);
      submit_data.append("is_active", this.data.is_active ? 1 : 0);

      this.$axios({
        method: "POST",
        url: "package_category",
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("addSuccess"),
            position: "bottomRight",
          });

          this.$router.push({ path: "/packages/show-all" });

          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
  },
  created() {
    // this.getCategories();
    this.canAdd = this.$permission.allowed("packages/add");
  },
};
</script>
